import type { Document, Task } from '@/shared/api/queries'

export interface TimelineEntry {
  id: string
  date: string
  kind: 'task' | 'document'
  task?: Task
  document?: Document
}

export function timelineOf(tasks: Task[], documents: Document[]): TimelineEntry[] {
  const entries: TimelineEntry[] = []

  for (const task of tasks) {
    if (task.status === 'open' && task.deadline) {
      entries.push({ id: `task-${task.id}`, date: task.deadline, kind: 'task', task })
    }
  }

  for (const document of documents) {
    if (document.expires_on) {
      entries.push({
        id: `document-${document.id}`,
        date: document.expires_on,
        kind: 'document',
        document,
      })
    }
  }

  return entries.sort((a, b) => a.date.localeCompare(b.date))
}

export interface TimelineMonth {
  key: string
  date: string
  entries: TimelineEntry[]
}

export function groupByMonth(entries: TimelineEntry[]): TimelineMonth[] {
  const months: TimelineMonth[] = []

  for (const entry of entries) {
    const key = entry.date.slice(0, 7)
    const last = months.at(-1)

    if (last?.key === key) {
      last.entries.push(entry)

      continue
    }

    months.push({ key, date: entry.date, entries: [entry] })
  }

  return months
}
